import React, { useState } from 'react';
import {
    Button,
    Grid,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions }
from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const AdminFunctionsSettings = ({ ...props }) => {

    const [open, setOpen] = useState(false);

    const { handleDeleteExportedPatientData } = props;

    const onDeleteExportedPatientData = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    };

    return(
        <Grid item xs={12}>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">Administrator Functions</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={onDeleteExportedPatientData}
                    >
                        Delete Exported Patient Data
                    </Button>
                </AccordionDetails>
            </Accordion>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Exported Patient Data Delete"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete exported patient data?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button
                    variant="contained"
                    onClick={e => handleDeleteExportedPatientData(e,setOpen)}
                    color="primary"
                >
                    Yes
                </Button>
                <Button
                    variant="contained"
                    onClick={handleClose}
                    color="primary"
                    autoFocus
                >
                    No
                </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}

export default AdminFunctionsSettings